import { useSelector } from 'react-redux'
import { RootState } from '../redux-store/store'

export default function useAuthentication() {
  const authentication = useSelector((state: RootState) => state.authentication)
  return authentication
}
